export interface Chapter {
  id: string;
  title: string;
  number: number;
  date: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: Chapter[];
  updatedAt: string;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '动作', slug: 'action' },
  { name: '悬疑', slug: 'mystery' },
  { name: '搞笑', slug: 'comedy' },
  { name: '剧情', slug: 'drama' },
  { name: '惊悚', slug: 'thriller' },
  { name: 'BL/GL', slug: 'bl-gl' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '某天成为公主',
    author: 'Spoon',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20elegant%20princess%20with%20blonde%20hair%20in%20ornate%20royal%20dress%2C%20fantasy%20palace%20background%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20clean%20composition%20with%20simple%20background%2C%20beautiful%20character%20centered&width=420&height=600&seq=comic-cover-01&orientation=portrait',
    description: '一觉醒来，我成了小说里注定要被父亲杀死的公主。为了活命，我决定攻略这个冷酷无情的皇帝父亲。然而事情的发展却远超我的想象……这是一部融合了奇幻与亲情的韩国漫改作品，画风精美绝伦，剧情温馨治愈。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '奇幻', '宫廷', '治愈'],
    status: '连载中',
    rating: 9.6,
    views: 1280000,
    chapters: [
      { id: 'ch1-1', title: '第1话：成为公主的那一天', number: 1, date: '2025-01-15' },
      { id: 'ch1-2', title: '第2话：冷酷的父亲', number: 2, date: '2025-01-22' },
      { id: 'ch1-3', title: '第3话：意外的温柔', number: 3, date: '2025-01-29' },
      { id: 'ch1-4', title: '第4话：皇室的秘密', number: 4, date: '2025-02-05' },
      { id: 'ch1-5', title: '第5话：命运的转折', number: 5, date: '2025-02-12' },
      { id: 'ch1-6', title: '第6话：隐藏的真相', number: 6, date: '2025-02-19' },
      { id: 'ch1-7', title: '第7话：新的开始', number: 7, date: '2025-02-26' },
      { id: 'ch1-8', title: '第8话：花园邂逅', number: 8, date: '2025-03-05' },
      { id: 'ch1-9', title: '第9话：暗流涌动', number: 9, date: '2025-03-12' },
      { id: 'ch1-10', title: '第10话：父亲的心', number: 10, date: '2025-03-19' },
    ],
    updatedAt: '2025-08-04',
  },
  {
    id: 'comic-2',
    title: '我独自升级',
    author: 'Chugong / Dubu',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20powerful%20male%20hunter%20with%20dark%20aura%20in%20black%20coat%2C%20action%20fantasy%20theme%2C%20dungeon%20portal%20glowing%20in%20background%2C%20dark%20dramatic%20lighting%2C%20Korean%20digital%20illustration%20style%2C%20intense%20atmosphere%2C%20simple%20background&width=420&height=600&seq=comic-cover-02&orientation=portrait',
    description: '十年前，世界各地出现了连接异次元的"门"，同时觉醒者们也随之出现。然而并不是所有的觉醒者都能变强，被称作"人类最弱兵器"的成振宇在一次双重地下城中濒死之际，意外获得了神秘系统的力量。从此，他踏上了独自变强的道路。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '奇幻', '升级', '热血'],
    status: '已完结',
    rating: 9.8,
    views: 3560000,
    chapters: [
      { id: 'ch2-1', title: '第1话：最弱猎人', number: 1, date: '2024-06-10' },
      { id: 'ch2-2', title: '第2话：双重地下城', number: 2, date: '2024-06-17' },
      { id: 'ch2-3', title: '第3话：神秘系统', number: 3, date: '2024-06-24' },
      { id: 'ch2-4', title: '第4话：每日任务', number: 4, date: '2024-07-01' },
      { id: 'ch2-5', title: '第5话：实力提升', number: 5, date: '2024-07-08' },
      { id: 'ch2-6', title: '第6话：副本挑战', number: 6, date: '2024-07-15' },
      { id: 'ch2-7', title: '第7话：暗影军团', number: 7, date: '2024-07-22' },
      { id: 'ch2-8', title: '第8话：S级猎人', number: 8, date: '2024-07-29' },
    ],
    updatedAt: '2025-07-28',
  },
  {
    id: 'comic-3',
    title: '她的私生活',
    author: '金成妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20beautiful%20young%20woman%20with%20long%20dark%20hair%20and%20casual%20modern%20outfit%2C%20office%20romance%20theme%2C%20warm%20soft%20lighting%2C%20cityscape%20window%20background%2C%20Korean%20digital%20illustration%20style%2C%20romantic%20mood%2C%20simple%20composition&width=420&height=600&seq=comic-cover-03&orientation=portrait',
    description: '美术馆策展人成德美，表面上是完美的职场精英，私下却是个追星十年的资深站姐。当她遇到新上任的馆长莱恩时，她的双重人生开始出现了意想不到的交集。一部关于追星、爱情与自我认同的都市浪漫喜剧。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '职场', '喜剧', '都市'],
    status: '已完结',
    rating: 9.3,
    views: 890000,
    chapters: [
      { id: 'ch3-1', title: '第1话：完美策展人', number: 1, date: '2024-08-01' },
      { id: 'ch3-2', title: '第2话：新来的馆长', number: 2, date: '2024-08-08' },
      { id: 'ch3-3', title: '第3话：站姐的秘密', number: 3, date: '2024-08-15' },
      { id: 'ch3-4', title: '第4话：意外暴露', number: 4, date: '2024-08-22' },
      { id: 'ch3-5', title: '第5话：他的条件', number: 5, date: '2024-08-29' },
      { id: 'ch3-6', title: '第6话：心跳加速', number: 6, date: '2024-09-05' },
    ],
    updatedAt: '2025-07-30',
  },
  {
    id: 'comic-4',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20young%20man%20with%20glasses%20holding%20a%20mysterious%20book%2C%20apocalyptic%20fantasy%20cityscape%20background%2C%20dramatic%20lighting%20with%20blue%20tones%2C%20Korean%20digital%20illustration%20style%2C%20intense%20storytelling%20vibe%2C%20simple%20composition&width=420&height=600&seq=comic-cover-04&orientation=portrait',
    description: '金独子是唯一一个追完了一部连载十年网文的人。就在小说完结的那一天，小说中的世界成为了现实。作为唯一知道这个世界结局的人，他将如何利用这一优势生存下去？',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '动作', '末世', '悬疑'],
    status: '连载中',
    rating: 9.7,
    views: 2100000,
    chapters: [
      { id: 'ch4-1', title: '第1话：十年追更', number: 1, date: '2025-03-01' },
      { id: 'ch4-2', title: '第2话：小说成真', number: 2, date: '2025-03-08' },
      { id: 'ch4-3', title: '第3话：第一幕开始', number: 3, date: '2025-03-15' },
      { id: 'ch4-4', title: '第4话：主角登场', number: 4, date: '2025-03-22' },
      { id: 'ch4-5', title: '第5话：剧情偏离', number: 5, date: '2025-03-29' },
      { id: 'ch4-6', title: '第6话：隐藏场景', number: 6, date: '2025-04-05' },
      { id: 'ch4-7', title: '第7话：星座的注视', number: 7, date: '2025-04-12' },
    ],
    updatedAt: '2025-08-03',
  },
  {
    id: 'comic-5',
    title: '甜蜜家园',
    author: '金坎比 / 黄英璨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20apartment%20building%20with%20ominous%20atmosphere%2C%20monster%20silhouette%20in%20shadows%2C%20survival%20horror%20theme%2C%20dark%20gritty%20lighting%20with%20red%20accents%2C%20Korean%20digital%20illustration%20style%2C%20tense%20mood%2C%20simple%20composition&width=420&height=600&seq=comic-cover-05&orientation=portrait',
    description: '因校园暴力而选择隐居的贤秀，在失去家人后独自搬进了一栋破旧的公寓楼。然而一场未知的灾难席卷世界，人们开始变成反映内心欲望的怪物。被困在公寓中的幸存者们，必须为生存而战。',
    category: '惊悚',
    categorySlug: 'thriller',
    tags: ['惊悚', '恐怖', '生存', '人性'],
    status: '已完结',
    rating: 9.5,
    views: 1850000,
    chapters: [
      { id: 'ch5-1', title: '第1话：搬进新家', number: 1, date: '2024-04-10' },
      { id: 'ch5-2', title: '第2话：第一声尖叫', number: 2, date: '2024-04-17' },
      { id: 'ch5-3', title: '第3话：怪物出现', number: 3, date: '2024-04-24' },
      { id: 'ch5-4', title: '第4话：封锁的公寓', number: 4, date: '2024-05-01' },
      { id: 'ch5-5', title: '第5话：幸存者的规则', number: 5, date: '2024-05-08' },
      { id: 'ch5-6', title: '第6话：内心的怪物', number: 6, date: '2024-05-15' },
    ],
    updatedAt: '2025-07-25',
  },
  {
    id: 'comic-6',
    title: '神之塔',
    author: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20mysterious%20tower%20reaching%20into%20the%20sky%2C%20young%20boy%20with%20determined%20expression%20looking%20up%2C%20fantasy%20adventure%20theme%2C%20celestial%20background%20with%20stars%2C%20Korean%20digital%20illustration%20style%2C%20epic%20scale%2C%20simple%20composition&width=420&height=600&seq=comic-cover-06&orientation=portrait',
    description: '二十五夜为了追寻唯一的朋友蕾哈尔，踏入了一座神秘的高塔。据说登上塔顶的人可以获得一切——财富、荣耀、权力，甚至成为神。在这座塔的每一层，都存在着残酷的考验和隐藏的真相。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '动作', '冒险', '史诗'],
    status: '连载中',
    rating: 9.4,
    views: 1650000,
    chapters: [
      { id: 'ch6-1', title: '第1话：塔之入口', number: 1, date: '2025-01-10' },
      { id: 'ch6-2', title: '第2话：第一层考验', number: 2, date: '2025-01-17' },
      { id: 'ch6-3', title: '第3话：铁壁的守卫者', number: 3, date: '2025-01-24' },
      { id: 'ch6-4', title: '第4话：队友与敌人', number: 4, date: '2025-01-31' },
      { id: 'ch6-5', title: '第5话：王的资质', number: 5, date: '2025-02-07' },
      { id: 'ch6-6', title: '第6话：隐藏的力量', number: 6, date: '2025-02-14' },
      { id: 'ch6-7', title: '第7话：第二层', number: 7, date: '2025-02-21' },
    ],
    updatedAt: '2025-08-01',
  },
  {
    id: 'comic-7',
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20beautiful%20young%20woman%20with%20flawless%20makeup%20transformation%2C%20before%20and%20after%20concept%2C%20school%20romance%20theme%2C%20pink%20and%20warm%20toned%20background%2C%20Korean%20digital%20illustration%20style%2C%20glamorous%20vibe%2C%20simple%20composition&width=420&height=600&seq=comic-cover-07&orientation=portrait',
    description: '因为外貌而遭受校园霸凌的周京，通过化妆技巧完成了惊人的变身，成为了学校里的"女神"。然而她始终活在真实面貌被揭穿的恐惧中。直到两个男生先后走近她的内心……',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '校园', '美妆', '成长'],
    status: '已完结',
    rating: 9.2,
    views: 2200000,
    chapters: [
      { id: 'ch7-1', title: '第1话：我不是丑小鸭', number: 1, date: '2024-05-10' },
      { id: 'ch7-2', title: '第2话：化妆的力量', number: 2, date: '2024-05-17' },
      { id: 'ch7-3', title: '第3话：校园女神诞生', number: 3, date: '2024-05-24' },
      { id: 'ch7-4', title: '第4话：两个男孩', number: 4, date: '2024-05-31' },
      { id: 'ch7-5', title: '第5话：素颜危机', number: 5, date: '2024-06-07' },
      { id: 'ch7-6', title: '第6话：真心还是假面', number: 6, date: '2024-06-14' },
      { id: 'ch7-7', title: '第7话：勇敢做自己', number: 7, date: '2024-06-21' },
    ],
    updatedAt: '2025-07-29',
  },
  {
    id: 'comic-8',
    title: '入赘女婿',
    author: 'Studio JBB',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20handsome%20man%20in%20modern%20suit%20with%20confident%20smile%2C%20business%20office%20luxury%20background%2C%20revenge%20drama%20theme%2C%20warm%20golden%20lighting%2C%20Korean%20digital%20illustration%20style%2C%20powerful%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-08&orientation=portrait',
    description: '被亲生家庭抛弃后，他入赘到了豪门千金家成了上门女婿。所有人都看不起他，称他为"吃软饭的废物"。然而没人知道，他其实是隐退的商界传奇。当妻子的家族企业遭遇危机时，他的真实身份即将浮出水面。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '都市', '复仇', '强者'],
    status: '连载中',
    rating: 9.1,
    views: 1450000,
    chapters: [
      { id: 'ch8-1', title: '第1话：豪门女婿', number: 1, date: '2025-04-01' },
      { id: 'ch8-2', title: '第2话：冷眼与嘲笑', number: 2, date: '2025-04-08' },
      { id: 'ch8-3', title: '第3话：暗处的力量', number: 3, date: '2025-04-15' },
      { id: 'ch8-4', title: '第4话：家族危机', number: 4, date: '2025-04-22' },
      { id: 'ch8-5', title: '第5话：初露锋芒', number: 5, date: '2025-04-29' },
      { id: 'ch8-6', title: '第6话：震惊全场', number: 6, date: '2025-05-06' },
    ],
    updatedAt: '2025-08-04',
  },
  {
    id: 'comic-9',
    title: '搞笑一家人',
    author: '赵锡',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20funny%20family%20portrait%20with%20exaggerated%20expressions%2C%20colorful%20comedy%20cartoon%20style%2C%20bright%20cheerful%20background%2C%20Korean%20digital%20illustration%20style%2C%20humorous%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-09&orientation=portrait',
    description: '这是一部关于韩国普通家庭的日常喜剧。从老爸的冷笑话到老妈的咆哮，从兄妹的斗嘴到奶奶的神吐槽，每一话都笑料百出。没有狗血剧情，只有让你捧腹大笑的平凡日常！',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '家庭', '日常', '温馨'],
    status: '连载中',
    rating: 9.0,
    views: 980000,
    chapters: [
      { id: 'ch9-1', title: '第1话：老爸的减肥计划', number: 1, date: '2025-02-15' },
      { id: 'ch9-2', title: '第2话：老妈的购物欲', number: 2, date: '2025-02-22' },
      { id: 'ch9-3', title: '第3话：兄妹大作战', number: 3, date: '2025-03-01' },
      { id: 'ch9-4', title: '第4话：奶奶的秘密', number: 4, date: '2025-03-08' },
      { id: 'ch9-5', title: '第5话：家庭会议', number: 5, date: '2025-03-15' },
      { id: 'ch9-6', title: '第6话：旅行囧途', number: 6, date: '2025-03-22' },
    ],
    updatedAt: '2025-08-02',
  },
  {
    id: 'comic-10',
    title: '杀戮跟踪',
    author: 'Koogi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20mysterious%20dark%20silhouette%20of%20two%20men%2C%20psychological%20thriller%20theme%2C%20blood%20red%20and%20black%20color%20palette%2C%20ominous%20atmosphere%20with%20shadowy%20background%2C%20Korean%20digital%20illustration%20style%2C%20tense%20mood%2C%20simple%20composition&width=420&height=600&seq=comic-cover-10&orientation=portrait',
    description: '吴尚宇一直暗恋着校园里的万人迷尹范，偷偷跟踪着他的一举一动。一天，他意外闯入了尹范家中，发现了一个令人毛骨悚然的秘密。一场扭曲的恋爱关系由此展开，走向了谁也无法预料的方向。',
    category: 'BL/GL',
    categorySlug: 'bl-gl',
    tags: ['BL', '悬疑', '心理', '黑暗'],
    status: '已完结',
    rating: 9.3,
    views: 1780000,
    chapters: [
      { id: 'ch10-1', title: '第1话：他的身影', number: 1, date: '2024-09-10' },
      { id: 'ch10-2', title: '第2话：闯入', number: 2, date: '2024-09-17' },
      { id: 'ch10-3', title: '第3话：地下室', number: 3, date: '2024-09-24' },
      { id: 'ch10-4', title: '第4话：共犯', number: 4, date: '2024-10-01' },
      { id: 'ch10-5', title: '第5话：扭曲的爱', number: 5, date: '2024-10-08' },
      { id: 'ch10-6', title: '第6话：失控', number: 6, date: '2024-10-15' },
      { id: 'ch10-7', title: '第7话：终局', number: 7, date: '2024-10-22' },
    ],
    updatedAt: '2025-07-26',
  },
  {
    id: 'comic-11',
    title: '狂王',
    author: '金仁淑 / 金在焕',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20fierce%20warrior%20king%20with%20battle%20armor%20holding%20sword%2C%20ancient%20Korean%20historical%20setting%2C%20epic%20battle%20theme%2C%20dramatic%20sunset%20sky%20background%2C%20Korean%20digital%20illustration%20style%2C%20powerful%20regal%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-11&orientation=portrait',
    description: '高丽末期，一个被流放的王子在绝境中崛起。他以铁腕手段统一了分裂的王国，却也在权力中渐渐迷失。兄弟反目、爱人离去、臣子背叛——登上王座的代价，从来都不只是血与铁。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '历史', '动作', '权谋'],
    status: '连载中',
    rating: 9.5,
    views: 1100000,
    chapters: [
      { id: 'ch11-1', title: '第1话：流亡王子', number: 1, date: '2025-03-10' },
      { id: 'ch11-2', title: '第2话：边境风云', number: 2, date: '2025-03-17' },
      { id: 'ch11-3', title: '第3话：王的归来', number: 3, date: '2025-03-24' },
      { id: 'ch11-4', title: '第4话：血染王城', number: 4, date: '2025-03-31' },
      { id: 'ch11-5', title: '第5话：铁王座', number: 5, date: '2025-04-07' },
      { id: 'ch11-6', title: '第6话：兄弟之战', number: 6, date: '2025-04-14' },
    ],
    updatedAt: '2025-08-03',
  },
  {
    id: 'comic-12',
    title: '假面女郎',
    author: 'Meme / 黄英璨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20mysterious%20woman%20wearing%20elegant%20mask%2C%20dark%20noir%20crime%20theme%2C%20city%20night%20background%20with%20neon%20lights%2C%20Korean%20digital%20illustration%20style%2C%20suspenseful%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-12&orientation=portrait',
    description: '白天是平凡无奇的上班族金貌美，夜晚却化身为网络直播间的性感假面女郎。然而一场意外让她的双重人生彻底崩塌，卷入了一系列不可挽回的事件中。一部探讨容貌焦虑与女性困境的黑暗悬疑佳作。',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '犯罪', '剧情', '社会'],
    status: '已完结',
    rating: 9.4,
    views: 1350000,
    chapters: [
      { id: 'ch12-1', title: '第1话：双面人生', number: 1, date: '2024-07-10' },
      { id: 'ch12-2', title: '第2话：直播间', number: 2, date: '2024-07-17' },
      { id: 'ch12-3', title: '第3话：那个夜晚', number: 3, date: '2024-07-24' },
      { id: 'ch12-4', title: '第4话：消失的证据', number: 4, date: '2024-07-31' },
      { id: 'ch12-5', title: '第5话：追捕', number: 5, date: '2024-08-07' },
      { id: 'ch12-6', title: '第6话：真相大白', number: 6, date: '2024-08-14' },
    ],
    updatedAt: '2025-07-27',
  },
  {
    id: 'comic-13',
    title: '她的沈清',
    author: 'Seri / 飞蝉',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20two%20beautiful%20women%20in%20traditional%20Korean%20hanbok%2C%20romantic%20GL%20theme%2C%20soft%20cherry%20blossom%20background%2C%20gentle%20pastel%20colors%2C%20Korean%20digital%20illustration%20style%2C%20elegant%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-13&orientation=portrait',
    description: '改编自韩国古典小说《沈清传》，以全新的女性视角重新诠释这个经典故事。沈清并非等待拯救的柔弱女子，而是一个勇敢追寻自己命运的独立女性。当她遇见龙王之女时，一段超越世俗的感情悄然绽放。',
    category: 'BL/GL',
    categorySlug: 'bl-gl',
    tags: ['GL', '古风', '爱情', '女性'],
    status: '连载中',
    rating: 9.6,
    views: 720000,
    chapters: [
      { id: 'ch13-1', title: '第1话：孝女沈清', number: 1, date: '2025-05-01' },
      { id: 'ch13-2', title: '第2话：出海', number: 2, date: '2025-05-08' },
      { id: 'ch13-3', title: '第3话：龙宫深处', number: 3, date: '2025-05-15' },
      { id: 'ch13-4', title: '第4话：公主的心意', number: 4, date: '2025-05-22' },
      { id: 'ch13-5', title: '第5话：重返人间', number: 5, date: '2025-05-29' },
    ],
    updatedAt: '2025-08-01',
  },
  {
    id: 'comic-14',
    title: '与神同行',
    author: '周浩旻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20afterlife%20underworld%20scene%20with%20mystical%20gates%2C%20spiritual%20fantasy%20theme%2C%20ethereal%20golden%20and%20white%20lighting%2C%20Korean%20digital%20illustration%20style%2C%20solemn%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-14&orientation=portrait',
    description: '消防员金自鸿在火灾中殉职后，被阴间使者带往地狱接受七七四十九天的审判。他必须在七大地狱中证明自己无罪，才能获得转世的机会。然而，地狱中的审判官们似乎藏着不可告人的秘密……',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '奇幻', '人性', '催泪'],
    status: '已完结',
    rating: 9.7,
    views: 2400000,
    chapters: [
      { id: 'ch14-1', title: '第1话：死后世界', number: 1, date: '2024-03-10' },
      { id: 'ch14-2', title: '第2话：杀人地狱', number: 2, date: '2024-03-17' },
      { id: 'ch14-3', title: '第3话：怠惰地狱', number: 3, date: '2024-03-24' },
      { id: 'ch14-4', title: '第4话：谎言地狱', number: 4, date: '2024-03-31' },
      { id: 'ch14-5', title: '第5话：不义地狱', number: 5, date: '2024-04-07' },
      { id: 'ch14-6', title: '第6话：背叛地狱', number: 6, date: '2024-04-14' },
      { id: 'ch14-7', title: '第7话：暴力地狱', number: 7, date: '2024-04-21' },
      { id: 'ch14-8', title: '第8话：天伦地狱', number: 8, date: '2024-04-28' },
    ],
    updatedAt: '2025-07-24',
  },
  {
    id: 'comic-15',
    title: '奶酪陷阱',
    author: 'Soonkki',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20university%20students%20in%20casual%20modern%20clothing%2C%20campus%20romance%20and%20psychological%20drama%20theme%2C%20warm%20autumn%20campus%20background%2C%20Korean%20digital%20illustration%20style%2C%20melancholy%20yet%20warm%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-15&orientation=portrait',
    description: '洪雪是一名努力打工赚学费的普通大学生。复学后她发现，表面上完美无缺的学长刘正似乎一直在暗中针对她。当她试图揭穿他的真面目时，却不知不觉陷入了一段复杂而危险的关系之中。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '校园', '心理', '剧情'],
    status: '已完结',
    rating: 9.5,
    views: 1900000,
    chapters: [
      { id: 'ch15-1', title: '第1话：复学第一天', number: 1, date: '2024-06-01' },
      { id: 'ch15-2', title: '第2话：完美学长', number: 2, date: '2024-06-08' },
      { id: 'ch15-3', title: '第3话：背后的目光', number: 3, date: '2024-06-15' },
      { id: 'ch15-4', title: '第4话：可疑的善意', number: 4, date: '2024-06-22' },
      { id: 'ch15-5', title: '第5话：真面目', number: 5, date: '2024-06-29' },
      { id: 'ch15-6', title: '第6话：奶酪陷阱', number: 6, date: '2024-07-06' },
    ],
    updatedAt: '2025-07-31',
  },
  {
    id: 'comic-16',
    title: '奇奇怪怪',
    author: '吴城垈',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20bizarre%20and%20surreal%20horror%20scene%20with%20twisted%20reality%2C%20creepy%20atmosphere%2C%20dark%20purple%20and%20green%20tones%2C%20Korean%20digital%20illustration%20style%2C%20unsettling%20mood%2C%20simple%20composition&width=420&height=600&seq=comic-cover-16&orientation=portrait',
    description: '由多个独立短篇恐怖故事组成的漫画集。每一话都是一个全新的恐怖故事——从都市怪谈到心理惊悚，从超自然现象到人性之恶。睡前慎点，因为你永远不知道下一个转角藏着什么。',
    category: '惊悚',
    categorySlug: 'thriller',
    tags: ['惊悚', '恐怖', '短篇', '怪谈'],
    status: '连载中',
    rating: 9.1,
    views: 1050000,
    chapters: [
      { id: 'ch16-1', title: '第1话：镜中人', number: 1, date: '2025-04-20' },
      { id: 'ch16-2', title: '第2话：电梯', number: 2, date: '2025-04-27' },
      { id: 'ch16-3', title: '第3话：隔壁房间', number: 3, date: '2025-05-04' },
      { id: 'ch16-4', title: '第4话：深夜便利店', number: 4, date: '2025-05-11' },
      { id: 'ch16-5', title: '第5话：影子', number: 5, date: '2025-05-18' },
    ],
    updatedAt: '2025-08-03',
  },
  {
    id: 'comic-17',
    title: '外貌至上主义',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20transformation%20of%20overweight%20boy%20to%20handsome%20fit%20man%2C%20school%20action%20theme%2C%20split%20before%20after%20composition%2C%20Korean%20digital%20illustration%20style%2C%20dramatic%20contrast%2C%20simple%20clean%20layout&width=420&height=600&seq=comic-cover-17&orientation=portrait',
    description: '朴亨硕因为肥胖和长相，在学校里长期遭受霸凌。一次偶然的机会，他意外获得了一具完美的身体。白天他以新身体去上学成为校园焦点，晚上回到原本的身体——这种双重人生能持续多久？',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '校园', '成长', '热血'],
    status: '已完结',
    rating: 9.0,
    views: 1500000,
    chapters: [
      { id: 'ch17-1', title: '第1话：最底层', number: 1, date: '2024-05-15' },
      { id: 'ch17-2', title: '第2话：第二身体', number: 2, date: '2024-05-22' },
      { id: 'ch17-3', title: '第3话：校园风云', number: 3, date: '2024-05-29' },
      { id: 'ch17-4', title: '第4话：地下格斗', number: 4, date: '2024-06-05' },
      { id: 'ch17-5', title: '第5话：身份的代价', number: 5, date: '2024-06-12' },
    ],
    updatedAt: '2025-07-30',
  },
  {
    id: 'comic-18',
    title: '柔美的细胞君',
    author: '李东建',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20cute%20cartoon%20cells%20inside%20brain%2C%20slice%20of%20life%20romance%20theme%2C%20bright%20playful%20colors%2C%20Korean%20digital%20illustration%20style%2C%20cheerful%20wholesome%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-18&orientation=portrait',
    description: '三十岁普通上班族柔美，她的每一个日常决定都是由体内的"细胞君"们开会投票决定的！从恋爱细胞到理性细胞，从食欲细胞到时尚细胞——这部作品用可爱的方式呈现了一个普通女性的内心世界与恋爱故事。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '恋爱', '日常', '治愈'],
    status: '已完结',
    rating: 9.4,
    views: 1750000,
    chapters: [
      { id: 'ch18-1', title: '第1话：相亲大作战', number: 1, date: '2024-08-15' },
      { id: 'ch18-2', title: '第2话：恋爱细胞苏醒', number: 2, date: '2024-08-22' },
      { id: 'ch18-3', title: '第3话：理性细胞的反击', number: 3, date: '2024-08-29' },
      { id: 'ch18-4', title: '第4话：约会细胞登场', number: 4, date: '2024-09-05' },
      { id: 'ch18-5', title: '第5话：分手细胞暴走', number: 5, date: '2024-09-12' },
      { id: 'ch18-6', title: '第6话：新的开始', number: 6, date: '2024-09-19' },
    ],
    updatedAt: '2025-07-28',
  },
  {
    id: 'comic-19',
    title: 'Dice: 骰子',
    author: '尹铉硕',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20mysterious%20glowing%20dice%20floating%20above%20a%20student%20hand%2C%20fantasy%20game%20theme%2C%20dark%20school%20corridor%20background%2C%20Korean%20digital%20illustration%20style%2C%20thrilling%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-19&orientation=portrait',
    description: '备受欺凌的高中生东太，某天收到了一颗神秘的骰子。每掷一次骰子，他就可以获得改变自身属性的机会——变帅、变聪明、变强壮。但随着骰子任务的难度不断升级，他发现自己正在玩一场无法退出的致命游戏。',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '奇幻', '校园', '游戏'],
    status: '已完结',
    rating: 9.2,
    views: 1300000,
    chapters: [
      { id: 'ch19-1', title: '第1话：神秘骰子', number: 1, date: '2024-04-05' },
      { id: 'ch19-2', title: '第2话：第一次投掷', number: 2, date: '2024-04-12' },
      { id: 'ch19-3', title: '第3话：任务开始', number: 3, date: '2024-04-19' },
      { id: 'ch19-4', title: '第4话：其他玩家', number: 4, date: '2024-04-26' },
      { id: 'ch19-5', title: '第5话：游戏规则', number: 5, date: '2024-05-03' },
      { id: 'ch19-6', title: '第6话：代价', number: 6, date: '2024-05-10' },
    ],
    updatedAt: '2025-07-25',
  },
  {
    id: 'comic-20',
    title: '附身',
    author: 'Koogi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20supernatural%20ghost%20possessing%20a%20human%20body%2C%20dark%20mystery%20theme%2C%20foggy%20night%20street%20background%2C%20Korean%20digital%20illustration%20style%2C%20eerie%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-20&orientation=portrait',
    description: '连续杀人魔死后发现自己的灵魂可以附身到他人身上。他利用这个能力继续他扭曲的杀戮，直到有一天，他附身到了一个警察身上，却发现自己逐渐被这个正直灵魂所影响……',
    category: '惊悚',
    categorySlug: 'thriller',
    tags: ['惊悚', '犯罪', '超自然', '心理'],
    status: '连载中',
    rating: 9.0,
    views: 870000,
    chapters: [
      { id: 'ch20-1', title: '第1话：死亡不是终点', number: 1, date: '2025-06-01' },
      { id: 'ch20-2', title: '第2话：新身体', number: 2, date: '2025-06-08' },
      { id: 'ch20-3', title: '第3话：猎人与猎物', number: 3, date: '2025-06-15' },
      { id: 'ch20-4', title: '第4话：警察的直觉', number: 4, date: '2025-06-22' },
    ],
    updatedAt: '2025-08-02',
  },
  {
    id: 'comic-21',
    title: '剑尊归来',
    author: 'LICO / 洪义正',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20ancient%20martial%20arts%20master%20with%20long%20sword%20in%20mountain%20setting%2C%20wuxia%20fantasy%20theme%2C%20traditional%20ink%20wash%20painting%20style%20blend%2C%20Korean%20digital%20illustration%20style%2C%20epic%20heroic%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-21&orientation=portrait',
    description: '天下第一剑客在击败魔教教主后神秘消失，百年之后以少年之身重现江湖。然而江湖早已不是他记忆中的模样——昔日辉煌的剑派沦为三流，曾经的朋友沦为仇敌。他以百年剑道沉淀，重铸剑尊之名。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '武侠', '奇幻', '热血'],
    status: '连载中',
    rating: 9.3,
    views: 1250000,
    chapters: [
      { id: 'ch21-1', title: '第1话：百年之后', number: 1, date: '2025-05-10' },
      { id: 'ch21-2', title: '第2话：没落的剑派', number: 2, date: '2025-05-17' },
      { id: 'ch21-3', title: '第3话：重拾剑道', number: 3, date: '2025-05-24' },
      { id: 'ch21-4', title: '第4话：初试锋芒', number: 4, date: '2025-05-31' },
      { id: 'ch21-5', title: '第5话：旧敌新仇', number: 5, date: '2025-06-07' },
    ],
    updatedAt: '2025-08-04',
  },
  {
    id: 'comic-22',
    title: '甜蜜的谎言',
    author: '李炫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20young%20couple%20in%20cozy%20cafe%20setting%2C%20sweet%20romance%20drama%20theme%2C%20warm%20candlelit%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20intimate%20mood%2C%20simple%20composition&width=420&height=600&seq=comic-cover-22&orientation=portrait',
    description: '因为一个善意的小谎言，两个原本无关的人开始了假扮情侣的生活。她需要摆脱家人的催婚压力，他需要躲避前任的纠缠。然而在日复一日的相处中，假的感情开始变得比真的还真。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '都市', '契约恋爱', '温馨'],
    status: '连载中',
    rating: 8.9,
    views: 760000,
    chapters: [
      { id: 'ch22-1', title: '第1话：假男友', number: 1, date: '2025-06-15' },
      { id: 'ch22-2', title: '第2话：见家长', number: 2, date: '2025-06-22' },
      { id: 'ch22-3', title: '第3话：心跳加速', number: 3, date: '2025-06-29' },
      { id: 'ch22-4', title: '第4话：他的过去', number: 4, date: '2025-07-06' },
    ],
    updatedAt: '2025-08-03',
  },
  {
    id: 'comic-23',
    title: '狂医之怒',
    author: '金秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20genius%20doctor%20in%20white%20coat%20with%20intense%20eyes%2C%20medical%20action%20theme%2C%20hospital%20emergency%20room%20background%2C%20Korean%20digital%20illustration%20style%2C%20dramatic%20professional%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-23&orientation=portrait',
    description: '被誉为"神之手"的天才外科医生，因一场医疗事故被吊销执照。当他发现事故背后的阴谋后，他决定用自己的方式复仇。手术刀不只是救人的工具，也可以成为制裁罪恶的武器。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '医疗', '复仇', '职场'],
    status: '连载中',
    rating: 9.1,
    views: 920000,
    chapters: [
      { id: 'ch23-1', title: '第1话：神之手', number: 1, date: '2025-04-15' },
      { id: 'ch23-2', title: '第2话：事故', number: 2, date: '2025-04-22' },
      { id: 'ch23-3', title: '第3话：坠落', number: 3, date: '2025-04-29' },
      { id: 'ch23-4', title: '第4话：觉醒', number: 4, date: '2025-05-06' },
      { id: 'ch23-5', title: '第5话：复仇之刃', number: 5, date: '2025-05-13' },
    ],
    updatedAt: '2025-08-01',
  },
  {
    id: 'comic-24',
    title: '社内恋爱',
    author: '郑多恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20office%20workers%20sharing%20secret%20glance%20across%20desks%2C%20workplace%20romance%20theme%2C%20bright%20modern%20office%20background%2C%20Korean%20digital%20illustration%20style%2C%20lighthearted%20atmosphere%2C%20simple%20composition&width=420&height=600&seq=comic-cover-24&orientation=portrait',
    description: '在同一家公司不同部门工作的两人，在公司的年度晚宴上一见钟情。然而公司明令禁止办公室恋情，他们不得不在同事面前装作陌生人。偷偷摸摸的恋爱虽然刺激，但纸终究包不住火……',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '恋爱', '职场', '浪漫'],
    status: '连载中',
    rating: 8.8,
    views: 680000,
    chapters: [
      { id: 'ch24-1', title: '第1话：年会之夜', number: 1, date: '2025-07-01' },
      { id: 'ch24-2', title: '第2话：秘密开始', number: 2, date: '2025-07-08' },
      { id: 'ch24-3', title: '第3话：危险的午餐', number: 3, date: '2025-07-15' },
      { id: 'ch24-4', title: '第4话：差点暴露', number: 4, date: '2025-07-22' },
    ],
    updatedAt: '2025-08-04',
  },
];

export const getComicsByCategory = (slug: string): Comic[] => {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categorySlug === slug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getHotComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestUpdates = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};

export const getRelatedComics = (comic: Comic, limit: number = 4): Comic[] => {
  return comics
    .filter((c) => c.id !== comic.id && c.categorySlug === comic.categorySlug)
    .slice(0, limit);
};